import React from 'react'

import CgtraderLogo from 'images/cgtrader_RGB_white.svg'

function FooterPresentation() {
  return (
    <section className="footer-presentation" aria-label="About CGTrader">
      <div className="footer-presentation__primary">
        <img
          className="footer-presentation__logo"
          src={CgtraderLogo}
          alt="CGTrader"
          width="180"
          height="40"
          loading="lazy"
        />
        <p className="footer-presentation__tagline">
          The world&apos;s largest 3D model marketplace.
        </p>
      </div>
    </section>
  )
}

export default FooterPresentation
